<div class="dialog-header">
    <h2 mat-dialog-title class="lmc-dialog-title">Custom Bank Account</h2>
    <button mat-icon-button [mat-dialog-close]="null" type="button"
            class="close-button" aria-label="Discard and close" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()" autocomplete="off">
    <mat-dialog-content>
        <p class="dialog-hint">
            Used for this transaction only — the customer's record on the loan is not changed.
        </p>

        <dl class="context">
            <dt>Loan Number</dt>
            <dd>{{ data.loanNumber || '—' }}</dd>
            <dt>Payee</dt>
            <dd>{{ data.payeeName || '—' }}</dd>
        </dl>

        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Use Account</button>
    </mat-dialog-actions>
</form>
